import { ISelectOption } from "./MultiSelect";

type StringToOptionConfig = {
  requiredValues?: readonly string[];   // optional: mark these as required
  dedupe?: boolean;                     // default true
  trim?: boolean;                       // default true
};

export const mapStringsToSelectOptions = (
  values: readonly string[] | null | undefined,
  config: StringToOptionConfig = {}
): ISelectOption[] => {
  const { requiredValues = [], dedupe = true, trim = true } = config;
  const requiredSet = new Set(requiredValues);

  const cleaned = (values ?? [])
    .map(v => (trim ? v.trim() : v))
    .filter(v => v.length > 0);

  const final = dedupe ? Array.from(new Set(cleaned)) : cleaned;

  return final.map(v => ({
    value: v,
    label: v,
    required: requiredSet.has(v),
  }));
};

export const mapSelectOptionsToStrings = (opts: readonly ISelectOption[]): string[] =>
  opts.map(o => o.value);